import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"

const AddVendorMaterialAdvance = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [companies, setCompanies] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plants, setPlants] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [vendors, setVendors] = useState([])
  const [categories, setCategories] = useState([])
  const [materialItems, setMaterialItems] = useState([])
  const [filteredItems, setFilteredItems] = useState([])
  const [selectedCategoryId, setSelectedCategoryId] = useState("")
  const [selectedCategoryName, setSelectedCategoryName] = useState("")
  const [quantity, setQuantity] = useState("")
  const [rate, setRate] = useState("")

  const a = r => Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []
  useEffect(() => { const load = async () => { try { const [co, pl, cc, cat, mi] = await Promise.all([api.get("companies"), api.get("plants"), api.get("centers"), api.get("categories"), api.get("material-items")]); setCompanies(a(co)); const p = a(pl); setAllPlants(p); setPlants(p); const c = a(cc); setAllCenters(c); setCenters(c); setCategories(a(cat)); setMaterialItems(a(mi)) } catch (e) { console.error("Load error:", e) } }; load() }, [])

  const showCompany = companies.length > 1
  const companyChange = async v => { setCenters(allCenters); setRoutes([]); setVendors([]); if (v) { try { setPlants(a(await api.get("plants-by-company/" + v))) } catch (e) { } } else setPlants(allPlants) }
  const plantChange = async v => { setRoutes([]); setVendors([]); if (v) { try { setCenters(a(await api.get("chillings-by-plant/" + v))) } catch (e) { } } else setCenters(allCenters) }
  const ccChange = async v => { setVendors([]); if (v) { try { setRoutes(a(await api.get("route-cc/" + v))) } catch (e) { } } else setRoutes([]) }
  const routeChange = async v => { if (v) { try { setVendors(a(await api.get("vendors"))) } catch (e) { } } else setVendors([]) }

  // Category selected → filter material items by category ID
  const categoryChange = e => {
    const catId = e.target.value
    setSelectedCategoryId(catId)
    setRate("")
    if (catId) {
      const cat = categories.find(c => String(c.id) === String(catId))
      setSelectedCategoryName(cat ? cat.materialCategory : "")
      // material_items.category stores the category ID as string/number
      const items = materialItems.filter(m => String(m.category) === String(catId))
      setFilteredItems(items)
    } else {
      setSelectedCategoryName("")
      setFilteredItems([])
    }
  }

  // Material item selected → auto-fill rate from item's price
  const itemChange = e => {
    const itemName = e.target.value
    if (itemName) {
      const item = materialItems.find(m => m.itemName === itemName)
      if (item && item.price) {
        // price may contain commas like "50,000" — strip them
        const cleanPrice = String(item.price).replace(/,/g, "")
        setRate(cleanPrice)
      }
    }
  }

  const parseNum = v => parseFloat((v || "0").replace(/,/g, "")) || 0
  const totalAmount = () => { const q = parseNum(quantity); const r2 = parseNum(rate); return (q * r2).toLocaleString("en-IN") }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    values.totalAmount = totalAmount()
    values.materialCategory = selectedCategoryName
    try {
      if (companies.length === 1) values.company = companies[0].id
      const r = await api.post("create-vendor-material-advance", values)
      if (r.data.success) {
        formRef.current.reset()
        setRoutes([]); setVendors([]); setQuantity(""); setRate("")
        setSelectedCategoryId(""); setSelectedCategoryName(""); setFilteredItems([])
        setSubmitted(true); setTimeout(() => setSubmitted(false), 3000)
      }
    } catch (e) { console.error("Submit error:", e) }
    setLoading(false)
  }

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader"><Row><Col md={6}><h4>Add Vendor Material Advance</h4></Col><Col md={6} style={{ textAlign: "right" }}><Link to="/vendor-material-advances" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col></Row></div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal" onValidSubmit={handleValidSubmit}>
          {showCompany && <Row><Col md={6}><div className="mb-3"><AvField type="select" name="company" label="Company *" required onChange={e => companyChange(e.target.value)}><option value="">Select Company</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col></Row>}
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="plant" label="Plant" onChange={e => plantChange(e.target.value)}><option value="">All Plants</option>{plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center *" required onChange={e => ccChange(e.target.value)}><option value="">Select Chilling Center</option>{centers.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route *" required onChange={e => routeChange(e.target.value)}><option value="">Select Route</option>{routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="bulkVendor" label="Vendor *" required><option value="">Select Vendor</option>{vendors.map((v, i) => <option key={i} value={v.id}>{v.vendorName}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="advanceDate" label="Advance Date *" type="date" required /></div></Col>
            <Col md={6}><div className="mb-3">
              <label className="form-label">Material Category *</label>
              <select className="form-control" value={selectedCategoryId} onChange={categoryChange} required>
                <option value="">Select Category</option>
                {categories.map((c, i) => <option key={i} value={c.id}>{c.materialCategory}</option>)}
              </select>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="materialItem" label="Material Item *" required onChange={itemChange}>
              <option value="">Select Item{selectedCategoryId ? ` (${filteredItems.length} items)` : ""}</option>
              {filteredItems.map((m, i) => <option key={i} value={m.itemName}>{m.itemName}{m.price ? ` — ₹${m.price}` : ""}</option>)}
            </AvField></div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="quantity" label="Quantity *" type="text" required value={quantity} onChange={e => setQuantity(e.target.value)} /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="rate" label="Rate (per unit) *" type="text" required value={rate} onChange={e => setRate(e.target.value)} /></div></Col>
            <Col md={4}><div className="mb-3"><label className="form-label">Total Amount</label><div className="form-control" style={{ background: "#f8f9fa", fontWeight: 700 }}>₹{totalAmount()}</div></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="deductionAmount" label="Deduction Per Bill *" type="text" required /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" /></div></Col>
          </Row>
          <div className="mb-3 row mt-4"><div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Material Advance Added!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end"><button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>{loading ? <><Spinner size="sm" /> Adding...</> : "Add Advance"}</button></div></div>
        </AvForm>
      </div>
    </div>
  )
}
export default AddVendorMaterialAdvance
